<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    //副组件通过provide 提供变量,子组件通过inject来注入
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      // 弃用
      //刷新页面
      // this.isRouterAlive = false;
      // this.$nextTick(function () {
      //   this.isRouterAlive = true;
      // });
    },
  },
};
</script>

<style lang='less'>
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.el-table .el-table__cell.is-center{
  text-align: left;
}
.glo_Table .el-table th.el-table__cell > .cell,.glo_Table .tabRightBtns{
  justify-content: flex-start!important;
}
.el-table-column--selection .cell{
  padding-left: 10px;
}
</style>
